import { faSlack, faSquarespace } from "@fortawesome/free-brands-svg-icons";
import { faChevronRight, faChevronDown, faCodeCompare, faLessThanEqual, faShirt, faTag, faTextWidth, faWeightScale } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import _ from 'lodash';
import React from 'react';
import colour_badge from '../../../assets/badge.png';
import solid_badge from '../../../assets/solid.svg';

export const TargetIcon = {
    "Weight": faWeightScale,
    "Width": faTextWidth,
    "Price": faTag,
    "MOQ": faLessThanEqual,
    "Fabric Type": faSlack,
    "Fabric Content": faSquarespace,
    "Finish": faCodeCompare,
    'Performance': faTag,
}

const ParentFilter = ({ data, handleMenuClick, selectedItems, setIsSecondModalOpen, isExpanded, onToggle }) => {
    const isMobile = useMediaQuery('(max-width: 767px)');
    const isDisabled = !localStorage.getItem('token');
    const selectedCategoryItems = selectedItems[data.name] || selectedItems[data.collectionName] || [];
    const selectedCount = _.size(selectedCategoryItems);
    const hasSelected = selectedCount > 0;
    const disabledClass = isDisabled ? "disabled" : "";

    return (
        <div
            className={`parent-filter-row ${disabledClass}`}
            key={data.categoryId}
            onClick={() => { if (onToggle) { onToggle(); } else { handleMenuClick(data); } (isMobile && (setIsSecondModalOpen(true))) }}
        >
            <div className="parent-filter-content">
                {
                    data.group === 'VISUAL' ? <img className='badge-img' src={`${data.name === 'Colour' ? colour_badge : solid_badge}?time=${Date.now()}`} alt="Badge" style={{ width: '1rem', height: '1rem' }} /> :
                        <FontAwesomeIcon icon={TargetIcon[data.name] || faShirt}
                            className={`parent-filter-icon ${hasSelected ? 'active' : ''}`}
                        />
                }
                <Text className={`parent-filter-text ${hasSelected ? 'active' : ''}`}>
                    {data.name}
                </Text>
            </div>
            <div className="parent-filter-actions">
                {hasSelected &&
                    <div className="badge-active-children">
                        {selectedCount}
                    </div>}
                <FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronRight} color="#273344" style={{ fontSize: "12px" }} />
            </div>
        </div>
    )
}

export default ParentFilter;
